<!--  -->
<template>
  <div class="training-head">
    <!-- 网站标题 -->
    <div class="head-left">
      <h1 class="head-title" @click="exitProject('home')">
        <img :src="Logo.img" alt="AI-training" class="head-title-img" />
      </h1>
      <!-- 文件夹下拉框 -->
      <div class="head-item head-file" v-if="userRole != 2">
        <el-dropdown
          class="head-file-dropdown"
          placement="bottom"
          @command="headFileCommand"
          :tabindex="tabindex_1"
        >
          <span class="el-dropdown-link" :class="{'events-disable':scoreHandle}" style="color:#fff">
            <i :class="['icon_box']" style="color:#fff;transform:scale(1.3)">
              <icon-base
                class="icon_nav-icon"
                :icon-name="Icons.NavFile.iconName"
                v-bind="Icons.NavFile"
              >
                <icon-nav-file />
              </icon-base>
            </i>
            文件
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item command="activeOpenPopup"
              >打开我的项目</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 功能操作 -->
      <div class="func-wrap">
        <el-button
          class="head-item head-save"
          :class="{'events-disable':scoreHandle}"
          @click="saveFile(buildingBlocksType.save)"
        >
          <img :src="saveProjectIcon" alt="" class="icon-del-head" />
          <span class="text">保存</span>
        </el-button>

        <el-button
          class="head-item head-delete"
          :class="{'events-disable':scoreHandle}"
          @click="deleteProject"
          v-if="userRole != 2"
        >
          <img :src="delProjectIcon" alt="" class="icon-del-head" />
          <span class="text">删除</span>
        </el-button>
        <el-button
         :class="{'events-disable':scoreHandle}"
          class="head-item head-publish"
          @click="onReleaseTraining"
          v-if="userRole == 1 || userRole == 3"
        >
          <img :src="publishProjectIcon" alt="" class="icon-publish-head" />
          <span class="text">
            {{ status === 2 ? '撤回发布' : '发布' }}
          </span>
        </el-button>
        <el-button class="head-item head-exit" @click="exitProject('back')">
          <img :src="exitProjectIcon" alt="" class="icon-publish-head" />
          <span class="text">退出</span>
        </el-button>
      </div>

      <!-- 头部编辑操作 -->
      <div class="head-edite-operate">
        <div class="training-name">
          <el-input
            v-model.trim="Train.trainingName"
            placeholder="请输入实训项目名称"
            maxlength="20"
            readonly
          ></el-input>
          <!-- @change="updateProject($event)" -->
          <!-- @keyup.enter.native="updateProject" -->
        </div>
        <div class="training-switch">
          <el-button class="switch-on" @click="changeMode">
            <i class="icon_box">
              <icon-base
                class="icon_mode-code"
                :icon-name="Icons.ModeCode.iconName"
                v-bind="Icons.ModeCode"
              >
                <icon-mode-code />
              </icon-base>
            </i>
            <span>{{ modeType }}</span>
          </el-button>
        </div>
        <!-- 帮助文档入口 -->
        <div class="help" @click="toDocPage" v-if="/(block|baseBlock)/.test(trainingType)">
          <icon-base
            class="help-icon"
            :icon-name="Icons.HeadHelp.iconName"
            v-bind="Icons.HeadHelp"
          >
            <icon-head-help />
          </icon-base>
        </div>
      </div>
    </div>

    <div class="head-right">
      <el-button
        v-if="false"
        :class="[
          'head-item',
          'submit-and-score',
          scored != 'scored'
            ? 'submit-unactive'
            : Project.Status == 3
            ? 'has-scored'
            : '',
        ]"
        @click="submitOrScore('score')"
        >{{ Project.Status == 3 ? '实训报告' : '评分' }}</el-button
      >
      <el-button
        v-if="false"
        :class="[
          'head-item',
          'submit-and-score',
          TrainId
            ? 'submit-unactive'
            : scored == 'scored'
            ? 'submit-unactive'
            : Status == 3
            ? 'submit-unactive'
            : Status == 2
            ? 'submit-unactive'
            : '',
        ]"
        @click="submitOrScore('submit')"
        >{{ Status == 2 ? '提交' : '提交' }}</el-button
      >
      <div class="run-btn" @click="runCodeHandler">
        <img class="icon-project" :src="iconRunCode" />
        <span class="text">运行代码</span>
      </div>

      <!-- <div class="userinfo-wrap"> -->
      <!-- TODO:分割线 -->
      <span class="col-line"></span>
      <div class="userinfo">
        <div class="profile">
          <img
            :src="
              accountInfo.photo
                ? /^(https?:\/\/)/.test(accountInfo.photo)
                  ? accountInfo.photo
                  : photoBaseUrl + accountInfo.photo
                : profile
            "
            alt
          />
        </div>
        <span class="el-dropdown-link header-name ellipsis" :title="accountInfo.realName">
          {{ accountInfo.realName }}
          <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
        </span>
        <span class="el-dropdown-link user-role">
          <!-- {{ accountInfo.userTenantRoleList[0].roleName }} -->
          {{ accountInfo.roleName }}
          <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
        </span>
      </div>
    </div>
    <!-- </div> -->
    <div class="popup-list">
      <!-- 打开项目 -->
      <gat-popup
        :class="['popup-open', popupActive === 'open' ? 'on' : 'off']"
        @cancel="cancelPopup"
        primaryButton="false"
        cancelButton="false"
      >
        <template v-slot:head>
          <nav class="open-tab-nav">
            <span :class="['open-tab', 'active']">我的项目</span>
            <!-- TODO:暂时无项目数据 -->
            <span class="open-tab active" v-if="false">课程项目</span>
          </nav>
        </template>
        <template v-slot:content>
          <div class="open-content">
            <div>
              <el-input
                class="open-content-search"
                v-model.trim="searchKey"
                placeholder="请输入项目名称"
                @keyup.enter.native="GetPageListByName"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="GetPageListByName"
                ></i>
              </el-input>
              <ul class="open-projects">
                <li class="open-projects-tips" v-if="projectList.records && projectList.records.length === 0">
                  <img :src="emptyImgUrl" alt="">
                  <span>{{searchKey ? '未检索到符合条件的项目' : '当前无项目'}}</span>
                </li>
                <li
                  class="open-project"
                  v-for="(item, idx) in projectList.records"
                  :key="item.projectId || idx"
                  @click="activeSelectProject(item)"
                >
                  <img class="cover" :src="Category.img01" alt />
                  <span class="title ellipsis" :title="item.projectName">{{ item.projectName }}</span>
                  <span class="dt-edit">
                    {{
                      item.editTime || item.createTime | moment('YYYY.MM.DD')
                    }}
                  </span>
                </li>
              </ul>
              <!-- 分页 -->
              <el-pagination
                v-if="projectList.records && projectList.records.length !== 0"
                @current-change="handleCurrentChange"
                background
                :current-page.sync="currentPage"
                :page-size="popupActive === 'openCreate' ? 4 : 6"
                :pager-count="5"
                layout="slot, prev, pager, next"
                :total="totalCount"
              ></el-pagination>
            </div>
          </div>
        </template>
        <template v-slot:buttons></template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteTraining"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">确定删除该项目吗？</span>
            </div>

            <div class="content">删除后将无法恢复</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
// 图标
import IconNavFile from '@/components/icons/typography/IconNavFile'
import IconNavSave from '@/components/icons/typography/IconNavSave'
import IconModeCode from '@/components/icons/typography/IconModeCode'
import IconHeadHelp from '@/components/icons/typography/HeadHelp'

import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'

// import IconUndoOrRedo from "@/components/icons/typography/UndoOrRedo";
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import GatPopup from '@/components/common/GatPopup'
import bus from '@/utils/bus'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'Editor',
  components: {
    IconNavFile,
    // IconNavSave,
    IconInfoHelp,
    IconModeCode,
    IconHeadHelp,
    GatPopup,
  },
  props: ['projectId', 'trainingId', 'editorType', 'trainingType','scoreHandle'],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      TrainId: '',
      trainingTypes: ['block', 'python', 'baseBlock'],
      popupActive: '',
      buildingBlocksType: {
        //积木类型
        answer: 1, //1项目题解t
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      Logo: {
        img: require('../../../../public/images/logo.png'),
      },
      tabindex_1: 1,
      Project: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: 'AI 人形机器人',
        BlocksFileUrl: '',
      },
      workspaceIsVisible: true,
      scored: '',
      Status: 1,
      iconRunCode: require('@/assets/images/ai-editor/icon-run.png'),
      profile: require('../../../../public/images/profile03.png'),
      User: {
        profile: require('../../../../public/images/profile03.png'),
        UserName: '',
      },
      Icons: {
        NavFile: {
          iconName: '文件',
          viewBox: '0 0 19 18',
          width: '19',
          height: '18',
          iconColor: '#fff',
        },
        NavSave: {
          iconName: '保存',
          viewBox: '0 0 18 19',
          width: '18',
          height: '19',
          iconColor: '#fff',
        },
        ModeCode: {
          iconName: '代码模式',
          viewBox: '0 0 16 15',
          width: '16',
          height: '15',
          iconColor: '#5883ff',
        },
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
        HeadHelp: {
          iconName: '使用文档',
          viewBox: '0 0 24 24',
          width: '24',
          height: '24',
          iconColor: '#fff',
        },
      },
      projectList: {
        records: [],
        size: 6,
        pageIndex: 1,
        current: 1,
        total: 0,
      },
      Cases: {
        records: [],
        size: 6,
        current: 1,
        total: 0,
      },
      currentPage: 1,
      proOperate: 0, //0个人 1公开;
      searchKey: '', // 自然状态
      pageStatus: 'normal', // normal 正常获取，search 搜索状态
      Category: {
        img01: require('../../../../public/images/img01.png'),
        img02: require('../../../../public/images/img02.png'),
      },
      saveProjectIcon: require('@/assets/images/ai-editor/icon-save.png'),
      delProjectIcon: require('@/assets/images/ai-editor/icon-del.png'),
      publishProjectIcon: require('@/assets/images/ai-editor/icon-publish.png'),
      exitProjectIcon: require('@/assets/images/ai-editor/quit-edit.png'),
      emptyImgUrl: require('@/assets/images/datasetLobby/icon-empty-box.png'),
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'Train', 'userRole']),
    totalCount() {
      return this.projectList.total ? this.projectList.total : 0
    },
    status() {
      let Train = this.Train
      console.log('Train.status', Train.status)
      return Train.status
    },
    userId() {
      return this.$store.state.accountInfo.userId
    },
    editorId() {
      return this.editorType
    },
    modeType() {
      let str = ''
      switch (this.trainingType) {
        case 'block':
          // 表示为实训为积木编辑器的头部组件
          str = this.workspaceIsVisible ? '查看代码' : '积木模式'
          break
        case 'baseBlock':
          // 表示为实训为海龟库编辑器的头部组件
          str = this.workspaceIsVisible ? '查看代码' : '积木模式'
          break
        case 'python':
          // 表示为实训为python编辑器的头部组件
          str = '代码模式'
          break
        default:
          break
      }
      return str
    },
  },
  watch: {},
  created() {},
  mounted() {
    let self = this
    bus.$on('getWorkspaceIsVisible', (workspaceIsVisible) => {
      self.workspaceIsVisible = workspaceIsVisible
    })
 
  },
  beforeDestroy() {
    bus.$off('getWorkspaceIsVisible')
  },
  methods: {
    toDocPage() {
            switch (this.trainingType) {
        case 'block':
            window.open('/projects/aiTEditor/helpdocument')
          break
        case 'baseBlock':
            window.open('/projects/base/helpdocument')
          break
        case 'python':
          break
        default:
          break
      }
    
    },
    runCodeHandler() {
      bus.$emit('codeRunHandle')
      bus.$emit('changeRightSide', 'codeRun')
    },
    deleteProject() {
      this.popupActive = 'delete'
    },
    async deleteTraining() {
      let { trainingId } = this,
        data = {
          trainingId,
        }
      let res = await PROJECTS.deleteTraining(data)
      if (res && res.isSuccess) {
        this.$router.go(-1)
      }
    },
    headFileCommand(command) {
      this[command]()
    },
    // 打开我的项目
    activeOpenPopup() {
      if(!this.workspaceIsVisible){
         this.workspaceIsVisible = true
        this.changeMode()
      }
      this.popupActive = 'open'
      this.currentPage = 1
      this.projectList.size = 6
      this.GetPageList()
    },
    // 获取项目分页
    GetPageList(activePageIndex, type) {
      var pageIndex = activePageIndex
          ? activePageIndex
          : this.projectList.current
          ? this.projectList.current
          : 1,
        pageSize = this.projectList.size ? this.projectList.size : 6,
        proOperate = type || this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          proOperate,
          userId,
          editorId,
          pageNum: pageIndex,
          pageSize: pageSize,
        }
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          if (type === 1) {
            //公开的项目列表
            this.Cases = result.data
          } else {
            //项目列表
            this.projectList = result.data
          }
        }
      })
    },
    // 搜索获取项目分页
    GetPageListByName(activePageIndex) {
      var pageIndex =
          typeof activePageIndex === 'number'
            ? activePageIndex
            : this.projectList.pageIndex
            ? this.projectList.pageIndex + 1
            : 1,
        pageSize = this.projectList.size ? this.projectList.size : 6,
        projectName = this.searchKey,
        proOperate = this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          proOperate,
          userId,
          editorId,
          pageNum: pageIndex,
          pageSize,
        }
      if (projectName) {
        data.projectName = projectName
      }
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          this.projectList = result.data
          this.pageStatus = 'search'
        }
      })
    },
    // 分页
    handleCurrentChange(pageIdx) {
      var pageStatus = this.pageStatus
      if (pageStatus === 'normal') {
        this.GetPageList(pageIdx)
      } else if (pageStatus === 'search') {
        this.GetPageListByName(pageIdx)
      }
    },
    activeSelectProject(project) {
      let { buildingBlocks, pythonCode } = project
      if (this.trainingType == 'block' || this.trainingType == 'baseBlock') {
        //积木编辑器、海龟库编辑时的处理
        if (buildingBlocks) {
          this.$parent.blockXmlText = ''
          setTimeout(() => {
            this.$parent.blockXmlText = buildingBlocks //更新编辑器工作台脚本
          }, 100)
        }
      } else if (this.trainingType == 'python') {
        //python编辑器时的处理
        if (pythonCode) {
          this.$parent.pythonEditorCode = ''
          setTimeout(() => {
            this.$parent.pythonEditorCode = pythonCode //更新编辑器工作台脚本
          }, 100)
        }
      }
      if (!buildingBlocks && !pythonCode) {
        this.$message.warning('该项目没有脚本')
      }
      this.popupActive = ''
    },
    cancelPopup() {
      this.popupActive = ''
    },
    // 发布/撤回发布
    onReleaseTraining(item) {
      let Train = this.Train,
        { status } = Train,
        trainingId = this.trainingId

      if (status == 0) {
        this.$message({
          message: '请先提交代码！',
          type: 'error',
        })
        return
      }

      if (status === 2) {
        status = 1
      } else {
        status = 2 //已提交未发布状态
      }

      let params = {
        status: status, // 实训状态
        trainingId: trainingId, // 实训id
      }

      PROJECTS.releaseTraining(params).then((result) => {
        // debugger;
        if (result.returnCode === 200) {
          if (status === 2) {
            this.$message.success('发布成功！')
          } else {
            this.$message.success('撤回成功！')
          }
          bus.$emit('getTrainingByTrainingId') //在aiGuideBook.vue重新获取项目信息
          // this.getTrainingListByCurriculumList();
        }
      })
    },
    exitProject(type) {
      // this.$router.go(-1);
      bus.$emit('beforeLeave', type)
    },
    saveFile: debounce(function(type) {
      if (!this.Train.trainingName) {
        return this.$message.error('实训项目名称不能为空！')
      }
      this.$emit('saveFile', type)
    }, 500),
    updateProject(event) {},
    changeMode() {
      bus.$emit('changeMode')
      //  switch (this.trainingType) {
      //   case 'block':
      //     bus.$emit('changeMode')
      //     break
      //   case 'python':
      //    bus.$emit('changeMode')
      //     break
      //   default:
      //     break
      // }
    },
  },
  //methods end
  updated() {},
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './trainingHead.scss';
</style>
